import { startOfDay } from "date-fns";
import { SEM_SALA } from "./agenda-drag";

export type SalaDaColuna = { id: string; nome: string; cor: string | null };

/** Uma coluna da grade: um dia (vista normal) ou uma sala daquele dia (agenda por sala). */
export type ColunaDaAgenda = { chave: string; date: Date; sala?: { chave: string; nome: string; cor: string | null } };

const chaveDoDia = (d: Date | string) => startOfDay(new Date(d)).toISOString();

/** A sala no destaque do arraste: undefined fora da agenda por sala. */
export const salaDoSlot = (salaId: string | null | undefined) => (salaId === undefined ? undefined : (salaId ?? SEM_SALA));

/** Em que coluna a consulta cai. */
export const colunaDaConsulta = (a: { date: Date | string; salaId?: string | null }, porSala: boolean) =>
  porSala ? `${chaveDoDia(a.date)}|${a.salaId ?? SEM_SALA}` : chaveDoDia(a.date);

/**
 * As colunas da grade. Por sala: as ativas na ordem, as desativadas que ainda têm consulta no dia
 * (senão a consulta sumiria da grade) e "Sem sala" no fim.
 */
export function colunasDaAgenda(dias: Date[], salas: SalaDaColuna[] | null, consultas: { date: Date | string; salaId?: string | null; sala?: SalaDaColuna | null }[]): ColunaDaAgenda[] {
  if (!salas || dias.length !== 1) return dias.map((d) => ({ chave: chaveDoDia(d), date: d }));
  const dia = dias[0]!;
  const doDia = consultas.filter((c) => chaveDoDia(c.date) === chaveDoDia(dia));
  const todas = [...salas];
  for (const c of doDia) {
    if (c.salaId && c.sala && !todas.some((s) => s.id === c.salaId)) todas.push(c.sala);
  }
  return [
    ...todas.map((s) => ({ chave: `${chaveDoDia(dia)}|${s.id}`, date: dia, sala: { chave: s.id, nome: s.nome, cor: s.cor } })),
    { chave: `${chaveDoDia(dia)}|${SEM_SALA}`, date: dia, sala: { chave: SEM_SALA, nome: "Sem sala", cor: null } },
  ];
}
